import { Avatar, AvatarFallback } from '@monetr/interface/components/Avatar';
import { useIconSearch } from '@monetr/interface/hooks/useIconSearch';
import mergeClasses from '@monetr/interface/util/mergeClasses';

import avatarStyles from './Avatar.module.scss';
import merchantIconStyles from './MerchantIcon.module.scss';

export interface MerchantIconProps {
  name?: string;
  className?: string;
}

export default function MerchantIcon(props: MerchantIconProps): React.JSX.Element {
  const icon = useIconSearch(props?.name ?? '');
  const size = 30;
  if (icon?.svg) {
    // It is possible for colors to be missing for a given icon. When this happens just fall back to a black color.
    const colorStyles =
      icon?.colors?.length > 0 ? { backgroundColor: `#${icon.colors[0]}` } : { backgroundColor: '#000000' };

    const styles = {
      // TODO Add mask image things for other browsers.
      WebkitMaskImage: `url(data:image/svg+xml;base64,${icon.svg})`,
      WebkitMaskRepeat: 'no-repeat',
      height: `${size}px`,
      width: `${size}px`,
      ...colorStyles,
    };

    return (
      <div className={mergeClasses(avatarStyles.avatar, merchantIconStyles.merchantIcon, props.className)}>
        <div style={styles} />
      </div>
    );
  }

  // If we have no icon to work with then create an avatar with the first character of the transaction name.
  const letter = props?.name?.toUpperCase().charAt(0) || '?';
  return (
    <Avatar className={props.className}>
      <AvatarFallback>{letter}</AvatarFallback>
    </Avatar>
  );
}
